// A '.tsx' file enables JSX support in the TypeScript compiler, 
// for more information see the following page on the TypeScript wiki:
// https://github.com/Microsoft/TypeScript/wiki/JSX

import React from 'react';
import MessageBox from './../controls/messagebox/MessageBox';
import Loading from './../controls/Loading';
import NoAccess from './../static/NoAccess';
import NoEntitlement from './../static/NoEntitlement';
import NoLicense from './../static/NoLicense';
import SystemStore from './../../stores/SystemStore';
declare var InovxLoader: any;

const getPrintOptions = (): { [id: string]: string } => {
    const systemStore = SystemStore as ISystemStore & { getPrintOptions?: () => { [id: string]: string } };
    return systemStore.getPrintOptions ? systemStore.getPrintOptions() : {};
};

interface LoaderProps {
    appReady: boolean;
    className?: string;
    styles?: any;
    errorStatus?: number;
    subApp?: boolean;
    children?: React.ReactNode;
}
interface LoaderState {
    loading?: boolean;
    printOptions?: { [id: string]: string };
}

class ReactLoader extends React.Component<LoaderProps, LoaderState> {
    _mounted: boolean;

    constructor(props: LoaderProps) {
        super(props);
        this._mounted = false;
        this._onChange = this._onChange.bind(this);
        
        var that = this;
        if (InovxLoader.isLoading) {
            this.state = {
                loading: true,
                printOptions: getPrintOptions()
            };

            InovxLoader.loaded(function () {
                that._onChange({
                    loading: false
                });
            });
        }
        else {
            this.state = {
                loading: false,
                printOptions: getPrintOptions()
            };
        }
    }

    private _onChange = (event: any) => {
        // TODO?!
        //if (this._mounted) {
            this.setState(event);
        // } else {
        //     this.state = event;
        // }
    }

    private _change = () => {
        this.setState({
            printOptions: getPrintOptions()
        });
    }

    componentDidMount() {
        SystemStore.addChangeListener(this._change);
    }

    componentWillUnmount() {
        SystemStore.removeChangeListener(this._change);
    }

    conditionalRender() {
        if (this.props.errorStatus) {
            switch (this.props.errorStatus) {
                case 403:
                    return (<NoAccess />);
                case 420:
                    return (<NoEntitlement />);
                case 440:
                    return (<NoLicense />);
            }
        }

        if (this.state.loading || !this.props.appReady) {
            return (<Loading />);
        } else {
            return this.props.children;
        }
    }

    render() {
        let className = 'react-loader';

        for (let i in this.state.printOptions) {
            className += ` ${this.state.printOptions[i]}`;
        }

        var divProps: any = {
            className: className
        };
        if(this.props.className) {
            divProps.className += ' ' + this.props.className;
        }
        if(this.props.styles !== undefined) {
            divProps.style = this.props.styles;
        }
        return (
            <div {...divProps}>
                { this.conditionalRender() }
                {this.props.subApp ? null : <MessageBox />}
            </div>
        );
    }
}

export default ReactLoader;